export default __webpack_public_path__ + "static/media/lic.953118e9.svg";